module.exports = __webpack_public_path__ + "img/b_AnevilSirop_left.3ecba7fe.jpeg";